import superagent from "superagent";

const methods = {
  get: (url, data) => {
    return superagent.get(url).query(data);
  },
  post: (url, data) => {
    return superagent.post(url).send(data);
  },
  put: (url, data) => {
    return superagent.put(url).send(data);
  },
  delete: (url) => {
    return superagent.delete(url);
  }
};

function setHeaders(headers) {
  return {
    "X-CSRF-Token": app.csrfToken,
    'X-Requested-With': 'XMLHttpRequest',
    ...headers
  };
}

function handleError(error) {
  if (error.status === 401) {
    // window.location.reload();
  }
  
  return error;
}

export default function request(url, method = "get", data, headers) {
  return methods[ method ](url, data)
    .set("Content-Type", "application/json")
    .timeout({
      response: 10000,  // Wait for the server to start sending,
      deadline: 30000, // allow for the file to finish loading.
    })
    .withCredentials()
    .set(setHeaders(headers))
    .then(
      (response) => {
        return response.type === "text/plain" ? response.text : response.body;
      },
      (error) => {
        handleError(error);
        return error.response.type === 'text/plain' ? error.response.text : error.response.body;
      }
    );
}

//TODO:
export function request2(url, method = "get", data, headers) {
  return methods[ method ](url, data)
    .set("Content-Type", "application/json")
    .timeout({
      response: 10000,  // Wait for the server to start sending,
      deadline: 30000, // allow for the file to finish loading.
    })
    .set(setHeaders(headers))
    .then(
      (response) => {
        return response.type === "text/plain" ? response.text : response.body;
      },
      (error) => {
        handleError(error);
        return error.response.type === 'text/plain' ? error.response.text : error.response.body;
      }
    );
}



// WEBPACK FOOTER //
// ./api/request.js